import { getAppUrl } from '@crm/utils'
import { Link, LinkProps } from 'react-router-dom'

interface Props extends LinkProps {
  to: string
}

export const AppLink = ({ to, ...props }: Props) => (
  <Link to={getAppUrl(to)} {...props} />
)
